var map = {
	"./desenvolvedor/desenvolvedor-principal.module": [
		"BOoi",
		"default~desenvolvedor-desenvolvedor-principal-module~pesquisa-pesquisa-principal-module",
		"desenvolvedor-desenvolvedor-principal-module"
	],
	"./detalhamento-produto/detalhamento-produto.module": [
		"Tyj/",
		"detalhamento-produto-detalhamento-produto-module"
	],
	"./home/home-initial.module": [
		"dnXa",
		"default~home-home-initial-module~pesquisa-pesquisa-principal-module",
		"home-home-initial-module"
	],
	"./pesquisa/pesquisa-principal.module": [
		"eyzj",
		"default~desenvolvedor-desenvolvedor-principal-module~pesquisa-pesquisa-principal-module",
		"default~home-home-initial-module~pesquisa-pesquisa-principal-module",
		"pesquisa-pesquisa-principal-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;